<template>
  <div class="w-100 advanced-search public-3d-search d-flex column flex-grow">
    <vx-card>
      <div class="vx-row gutter-half d-flex align-center">
        <div class="vx-col custom-input-group mb-0 concepts-search" style="flex-grow: 1;">
          <div class="d-flex align-center input-cnt">
            <div class="label">
              Search:
            </div>
            <div class="relative flex-grow">
              <vs-input loading v-model="filters._search"
                        style="width: 100%"
                        @keypress.enter="fetchItems(false)"
                        placeholder="Type a topic to search related content."
                        class="has-icons"
              />
              <div class="icons">
                <feather-icon v-if="filters._search" icon="XIcon"
                              svgClasses="h-6 w-6 cursor-pointer"
                              @click="clearSearch"
                              style="opacity: 0.7; margin-right: 5px;" />
                <div v-if="isLoading" class="vs-input__loading"
                     style="margin-left: 5px;" />
                <feather-icon
                  @click="fetchItems(false)"
                  v-else
                  style="margin-right: 5px;"
                  icon="SearchIcon" svgClasses="h-6 w-6 cursor-pointer" :class="{'active-search-btn': isLoading}" />
              </div>
            </div>
            <vs-button id="search-btn" class="ml-5" color="primary" @click="fetchItems(false)">
              Search
            </vs-button>
          </div>
        </div>
      </div>
      <div v-if="$route.meta.lmEnabled"
           class="vx-row gutter-half d-flex align-center">
        <div class="vx-col w-full sm:w-full md:w-1/3" :class="{'filter-disabled': !exams.length}">
          <div class="d-flex align-center input-cnt">
            <span class="label">Grade: </span>
            <v-select name="Grade"
                      class="flex-grow  right"
                      placeholder="Select Grade"
                      :options="exams"
                      label="display_name"
                      @input="selectExam"
                      :searchable="false"
                      :value="filters.exam"
                      :disabled="!exams.length" />
          </div>
        </div>
        <div class="vx-col w-full sm:w-full md:w-1/3" :class="{'filter-disabled': !subjects.length}">
          <div class="d-flex align-center input-cnt">
            <span class="label">Subject: </span>
            <v-select name="subject"
                      class="flex-grow  left"
                      placeholder="Select Subject"
                      :options="subjects"
                      label="display_name"
                      :searchable="false"
                      :disabled="!subjects.length"
                      :value="filters.subject"
                      @input="selectSubject" />
          </div>
        </div>
        <div class="vx-col w-full sm:w-full md:w-1/3" :class="{'filter-disabled': !chapters.length}">
          <div class="d-flex align-center input-cnt">
            <span class="label">Chapter: </span>
            <v-select name="chapter"
                      class="flex-grow  right"
                      placeholder="Select Chapter"
                      :options="chapters"
                      label="title"
                      :disabled="!chapters.length"
                      :searchable="false"
                      @input="selectChapter"
                      :value="filters.chapter" />

          </div>
        </div>
      </div>
    </vx-card>
    <!-- <vx-card>
      <div class="search-total-items">
        <div class="search-total-items-title">Total items:</div>
        <div class="search-total-items-value">{{ totalItemsCount.toLocaleString("en") }}</div>
      </div>
    </vx-card> -->
    <div class="pr">
      <div class="loader-block loader-block2" v-if="isLoading" style="min-height: 200px;">
        <div class="loading">
          <div class="effect-1 effects"></div>
          <div class="effect-2 effects"></div>
          <div class="effect-3 effects"></div>
        </div>
      </div>
      <div class="vx-row">
        <SmartClickWrapper class="vx-col custom-asset-card mb-base w-1/2 sm:w-1/3 lg:w-1/5 d-flex"
                           v-for="item in items" :key="item.asset_object_id" :onClick="() => showGlobalAsset(item)">
          <GlobalAssetItem :item="item" :isMyLibrary="true" />
        </SmartClickWrapper>
      </div>
      <div class="mb-5" style="text-align: center"
           v-if="showLoadMore">
        <vs-button color="primary" :disable="isLoading" @click="loadMore" style="width: 150px">
          Load more
        </vs-button>
      </div>
    </div>
    <public3d-modal :asset="assetModal" v-if="assetModal" @close="assetModal = null"/>
  </div>
</template>

<script>

import axios from "axios";
import vSelect from 'vue-select'
import GlobalAssetItem from "../components/GlobalAssetItem";
import CustomSvg from "../components/CustomSvg";
import assetModal from "../components/modal/assetModal";
import { getGoalsExamsSubjects } from "@/utils/fetchers/getGoalsExamsSubjects.js";
import { getUnits } from "@/utils/fetchers/getUnits.js";
import SmartClickWrapper from "@/components/SmartClickWrapper.vue";
import Iframe from "@/views/Iframe.vue";
import Public3dModal from "@/components/modal/public3dModal.vue";

export default {
  name: "GlobalSearch",
  components: {Public3dModal, Iframe, SmartClickWrapper, vSelect, GlobalAssetItem, CustomSvg, assetModal},
  props: {},
  data() {
    return {
      filters: {
        _search: "",
        goal: '',
        exam: '',
        subject: "",
        unit: "",
        chapter: "",
        topic: "",
        title: "",
        licence: "",
        // asset_types: [],
        // _start: 0,
        // _limit: 27,
        imageType: "image",
        order_by: "updatedAt",
        order: "desc",
        academic_reviewed: 'any',
        artist_reviewed: 'any',
        visibility: 'any',
        // published: true,
        lm_format_id: '',
        lm_format: {name: "Teaching for school", value: "K12"},
        is_ar_links: 'any',
        is_animated: false,
        ar_reviewed: 'any',
        voiceover: "",
        locale: "en",
      },
      goalsExamsSubjects: [],
      goals: [],
      exams: [],
      subjects: [],
      units: [],
      chapters: [],
      topics: [],
      curriculums: [
        {value: "K12", name: "Teaching for school"},
        {value: "PreUG", name: "Teaching for college entrance exams"},
        {value: "PrePG", name: "Teaching for government service exams"}
      ],
      items: [],
      currentPage: 1,
      totalItems3D: 0,
      itemsPerPage: 15,
      totalPages: 0,
      isLoading: true,
      lmDebounce: false,
      lmFormats: [],
      cancelSearchToken: [],
      assetModal: null,
      showLoadMore: false,
    }
  },
  computed: {
    totalItemsAmp() {
      return this.totalItems3D
    },
    totalItemsCount() {
      return this.totalItemsAmp;
    },
    filtersObj() {
      return {
        user_id: this.$store.state.user._id,
        query: this.filters._search,
        goal: (this.filters.goal || {}).code || "",
        exam: (this.filters.exam || {}).code || "",
        subject: (this.filters.subject || {}).code || "",
        unit: (this.filters.unit || {}).id || "",
        chapter: (this.filters.chapter || {}).id || "",
        topic: (this.filters.topic || {}).id || "",
        title: this.filters.title,
        asset_type: this.$store.state.globalSearchAssetTypes.includes("any") ? [] : this.$store.state.globalSearchAssetTypes,
        size: this.itemsPerPage,
        academic_reviewed: this.filters.academic_reviewed,
        artist_reviewed: this.filters.artist_reviewed,
        visibility: this.filters.visibility,
        published: this.$store.state.globalSearchPublished,
        is_ar_links: this.filters.is_ar_links,
        is_animated: this.filters.is_animated,
        ar_reviewed: this.filters.ar_reviewed,
        licence: this.filters.licence,
        locale: this.filters.locale,
      }
    },
    filtersQuery() {
      return Object.keys(this.filtersObj)
        .filter(k => k !== "locale")
        .filter(k => (k === 'query' && this.filtersObj[k]) || (!this.filtersObj.topic || !['goal', 'exam', 'subject', 'unit', 'chapter', 'topic'].includes(k)) && (k !=='is_animated' || this.filtersObj.asset_type.includes('3D')) && (Boolean(this.filtersObj[k]) && this.filtersObj[k] !== 'any' || this.filtersObj[k] === 0 || (k === 'academic_reviewed' || k === 'artist_reviewed' || k === 'published' || k === 'is_ar_links' || k === 'ar_reviewed') && this.filtersObj[k] !== 'any'))
        .map(k => {
          if (['academic_reviewed', 'artist_reviewed', 'visibility', 'published', 'is_ar_links', 'ar_reviewed', 'is_animated'].indexOf(k) !== -1) {
            return `filter=${k}:${this.filtersObj[k]}`
          } else if (['goal', 'exam', 'subject', 'unit', 'chapter'].indexOf(k) !== -1) {
            return `filter=${k}_code.keyword:${this.filtersObj[k]}`
          } else {
            return `${k}=${this.filtersObj[k]}`
          }
        }).join("&")
    }
  },
  mounted() {
    this.fetchItems();
    getGoalsExamsSubjects(this.$route.meta.filterLm).then(data => {
      this.goalsExamsSubjects = data;
      this.selectGoal(this.goalsExamsSubjects.find(g => g.code === "kve97670"));
    })
  },
  watch: {
    filtersObj(next, prev) {
      if (this.items.length) {
        this.totalPages = 0;
      }
    }
  },
  methods: {
    showGlobalAsset(item) {
      if (item.variants_data && item.variants_data.coobo_library_link) {
        this.assetModal = item;
      }
    },
    loadMore() {
      this.currentPage++;
      this.fetchItems(true);
    },
    clear(fieldName) {
      const map = ['goals', 'exams', 'subjects', 'units', 'chapters', 'topics'].reverse();
      const clearMap = {
        goals: () => {
          this.goals = [];
          this.filters.goal = ''
        },
        exams: () => {
          this.exams = [];
          this.filters.exam = ''
        },
        subjects: () => {
          this.subjects = [];
          this.filters.subject = ''
        },
        units: () => {
          this.units = [];
          this.filters.unit = ''
        },
        chapters: () => {
          this.chapters = [];
          this.filters.chapter = ''
        },
        topics: () => {
          this.topics = [];
          this.filters.topic = ''
        },
      }
      let ind = map.indexOf(fieldName);
      this.currentPage = 1;
      this.totalPages = 0;
      if (ind < 0) return;
      for (let i = 0; i <= ind; i++) {
        clearMap[map[i]]();
      }
    },
    selectCurriculum(curriculum) {
      this.filters.lm_format = curriculum;
      this.clear("goals");
      if (curriculum) {
        this.goals = this.goalsExamsSubjects.filter(g => g.type === curriculum.value);
      }
    },
    selectGoal(goal) {
      this.filters.goal = goal;
      this.clear("exams");
      if (goal) {
        this.exams = goal.exam.filter(e => e.subjects && e.subjects.length);
      }
    },
    selectExam(exam) {
      this.filters.exam = exam;
      this.clear("subjects");
      if (exam) {
        this.subjects = exam.subjects.filter(s => (s.display_name !== "Social Science" && s.display_name !== "Mathematics"));
      }
      this.fetchItems();
    },
    selectSubject(subject) {
      this.filters.subject = subject;
      this.clear("units");
      if (subject) {
        getUnits(subject.code, this.filtersObj.locale).then((units) => {
          this.chapters = units.map(u => u.children).flat();
        });
      }
      this.fetchItems();
    },
    selectUnit(unit) {
      this.filters.unit = unit;
      this.clear("chapters");
      if (unit) {
        this.chapters = unit.children;
      }
    },
    selectChapter(chapter) {
      this.filters.chapter = chapter;
      this.clear("topics");
      if (chapter) {
        this.topics = chapter.children;
      }
      this.fetchItems();
    },
    clearSearch() {
      this.filters._search = "";
      this.isLoading = false;
      if (this.cancelSearchToken && this.cancelSearchToken.length && this.cancelSearchToken[0].cancel) {
        this.cancelSearchToken[0].cancel({err: "Operation canceled by user action."});
      }
      this.fetchItems(false);
    },
    ampSearch(assetType) {
      return new Promise(resolve => {
        const kveCode = this.filtersObj.topic;
        if (this.cancelSearchToken && this.cancelSearchToken[0] && this.cancelSearchToken[0].cancel) {
          this.cancelSearchToken[0].cancel({err: "Operation canceled by new search.", newSearch: true});
        }
        this.cancelSearchToken = axios.CancelToken.source();
        let asset_types = [assetType];
        if (assetType === "image") {
          asset_types = this.$store.state.globalSearchAssetTypes.includes("any")
            ? ["image", "illustration", "cg_image"]
            : [this.filters.imageType];
        }
        const locale = this.filters.locale;
        const query = [
          this.filtersQuery,
          ...asset_types.map(asset_type => `filter=asset_type:${asset_type}`),
          kveCode ? `filter=meta_kve_codes.keyword:${kveCode}` : "",
          `start=${(this.currentPage - 1) * this.itemsPerPage}`,
          `locale=${locale}`,
          `filter=digital_india_visibility:true`,
          `sort_by=default`
        ].filter(s => s).join("&");
        const url = `${this.$route.name === 'advancedSearchNew' ? 'https://beta-api.embibe.com' : 'https://preprodms.embibe.com'}/fs_ms/v2/ampsearch?${query}`

        this.$axios.get(url, {cancelToken: this.cancelSearchToken.token}).then(res => {
          let items = [];
          let count = []
          if (res.data && res.data.content && res.data.content.length) {
            items = res.data.content;
          }
          if (res.data && res.data.metadata) {
            count = res.data.metadata.total
          }

          if (this.cancelSearchToken && this.cancelSearchToken[0]) {
            this.cancelSearchToken = this.cancelSearchToken.slice(1);
          }
          resolve({items, count, assetType})
        }).catch(e => {
          console.log('catch_search', e)
          this.isLoading = Boolean(e.message.newSearch);
          this.$root.removeLoading('#search-btn');
          if (this.cancelSearchToken && this.cancelSearchToken[0]) {
            this.cancelSearchToken = this.cancelSearchToken.slice(1);
          }
          resolve({error: true})
        })
      })
    },
    resetCounters() {
      this.totalItems3D = 0;
    },
    fetchItems(loadMore = false) {
      this.isLoading = true;
      this.$root.addLoading('#search-btn');
      clearTimeout(this.fetchDebounce);
      this.fetchDebounce = setTimeout(() => {
        if (!loadMore) {
          this.items = [];
          this.currentPage = 1;
          this.resetCounters()
        }
        let promises = [];
        promises.push(this.ampSearch("3D"));
        Promise.all(promises).then((results) => {
          this.items.push(...results.map(r => r.items || []).flat());
          this.showLoadMore = this.items.length && this.items.length % (this.currentPage * this.itemsPerPage) === 0
          results.forEach(r => {
            if ("count" in r && r.assetType) {
              const totalItemsKey = `totalItems${r.assetType.charAt(0).toUpperCase() + r.assetType.slice(1)}`;
              this[totalItemsKey] = r.count;
            }
          })
          this.isLoading = false;
          this.$root.removeLoading('#search-btn');
        })
      }, 500)
    },
  },
}
</script>

<style>
.public-3d-search .label {
  width: 95px;
}
.public-3d-search .v-select .vs__dropdown-menu .vs__dropdown-option {
  word-break: normal;
}
.public-3d-search .asset-modal.con-vs-popup .vs-popup {
  width: 100%;
  height: 100%;
}
.public-3d-search .card-img-block .loader-block .loading {
  top: 50%;
}
.public-3d-search .input-cnt {
  margin: 5px 0;
}
@media screen and (max-width: 600px) {
  #search-btn {
    display: none;
  }
  .public-3d-search .input-cnt {
    flex-wrap: wrap;
  }
  .public-3d-search .label {
    display: block;
    width: 100%;
    padding: 0 0 0 2px;
    height: auto;
    text-align: left;
    font-size: 12px;
  }
  .public-3d-search .custom-asset-card {
    padding: 0 0.5rem;
  }
  .public-3d-search .vx-row {
    margin: 0 -0.5rem;
  }
  .public-3d-search .vx-card .vx-card__collapsible-content .vx-card__body {
    padding: 1rem;
  }
}
</style>
